module.exports = __webpack_public_path__ + "assets/img/ic-export-p-blue.8f8e0359.svg";